import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { showAlert } from 'utility/SweetAlert'

const InteractorWarehouseInventoryHeaderView = () => {
  const warehouseInventoryHeaderView = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/inventory-header/view', payload, (response) => {
      if (response.code === 7200 && response.data) {
        callback(response.data)
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
        })
      }
      loading(false)
    })
  }, [])
  return { warehouseInventoryHeaderView }
}

export default InteractorWarehouseInventoryHeaderView
